import { Home, History, Settings } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const navItems = [
  { path: '/', icon: Home, label: 'Home' },
  { path: '/history', icon: History, label: 'History' },
  { path: '/settings', icon: Settings, label: 'Settings' },
];

const isNavItemActive = (pathname, path) => {
  if (path === '/') return pathname === '/';
  if (path === '/history') {
    return pathname === '/history' || pathname.startsWith('/historical-view');
  }
  return pathname === path || pathname.startsWith(`${path}/`);
};

export const Navigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  
  // Hide navigation on certain screens (onboarding uses the bar; passcode stays chromeless)
  const hiddenPaths = ['/passcode'];
  if (hiddenPaths.some(path => location.pathname.startsWith(path))) {
    return null;
  }

  return (
    <nav 
      className="fixed bottom-0 left-0 right-0 z-[100] backdrop-blur-xl bg-theme-light border-t border-theme-secondary pb-[env(safe-area-inset-bottom,0px)]"
      data-testid="bottom-navigation"
    >
      <div className="max-w-md mx-auto">
        {/* Navigation Tabs */}
        <div className="flex items-center justify-around py-2 px-4">
          {navItems.map(({ path, icon: Icon, label }) => {
            const isActive = isNavItemActive(location.pathname, path);
            
            return (
              <button
                key={path}
                onClick={() => navigate(path)}
                className="relative flex flex-col items-center gap-1 p-1.5 transition-colors"
                data-testid={`nav-${label.toLowerCase()}`}
                aria-label={label}
              >
                <div className="relative">
                  <Icon 
                    size={24} 
                    strokeWidth={1.5}
                    className={`transition-colors ${
                      isActive ? 'text-theme-accent' : 'text-secondary'
                    }`}
                  />
                  {isActive && (
                    <motion.div
                      layoutId="nav-indicator"
                      className="absolute -bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 bg-theme-accent rounded-full"
                      transition={{ type: 'spring', stiffness: 400, damping: 30 }}
                    />
                  )}
                </div>
                <span
                  className={`text-xs transition-colors ${
                    isActive ? 'text-theme-accent font-medium' : 'text-secondary'
                  }`}
                >
                  {label}
                </span>
              </button>
            );
          })}
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
